import React from "react";

import { Box, Typography } from "@mui/material";
import format from "date-fns/format";

type StartDateProps = {
  startDate: string | undefined;
};

const StartDate: React.FC<StartDateProps> = ({ startDate }) => {
  const formattedStartDate = format(
    new Date(startDate != undefined ? startDate : new Date()),
    "dd MMM, yyyy"
  );
  return (
    <Box
      marginLeft={{ xs: 0, md: 3 }}
      marginRight={3}
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      <Typography variant="body1" color="textSecondary">
        Start date:
      </Typography>
      <Typography variant="body1" color="textPrimary">
        {formattedStartDate}
      </Typography>
    </Box>
  );
};

export default StartDate;
